import { VideoProps } from '@src/quince-components/src'

import ContentfulVideo from './contentful/ContentfulVideo'

interface IVideo {
  readonly id: string
  readonly fileName: string
  readonly contentType: string
  readonly url: string
  readonly title?: string
  readonly description?: string
}

export default class Video implements IVideo {
  readonly id: string
  readonly fileName: string
  readonly contentType: string
  readonly url: string
  readonly title?: string
  readonly description?: string

  constructor({ url, id, fileName, contentType, title = undefined, description = undefined }: IVideo) {
    this.id = id
    this.url = url
    this.fileName = fileName
    this.contentType = contentType
    this.title = title
    this.description = description
    return {
      ...this,
    }
  }

  static makeVideoProps(video?: Video): VideoProps {
    if (!video) {
      return {
        id: '',
        url: '',
        contentType: '',
      }
    }
    return {
      id: video.id,
      url: video.url,
      contentType: video.contentType,
    }
  }

  static fromContentful(contentfulVideo: ContentfulVideo) {
    return new Video({
      url: contentfulVideo.file.url,
      id: contentfulVideo.id,
      fileName: contentfulVideo.file.fileName,
      contentType: contentfulVideo.file.contentType,
    })
  }
}
